export default __webpack_public_path__ + "static/img-homehero-1-56a6b25c457e424c9098cf01d17f87a1.webp";